import { api } from "./apiClient";
import { VisitaEntry } from "@/types/visita";

export const visitasService = {
  getAll: (start?: string, end?: string) => {
    const params = new URLSearchParams();
    if (start) params.set("start", start);
    if (end) params.set("end", end);
    const queryString = params.toString();
    const url = queryString ? `/visitas/?${queryString}` : "/visitas/";
    return api.get<VisitaEntry[]>(url);
  },

  create: (data: { coords: string; visita: string }, ownerId: string, userName: string) => {
    const params = new URLSearchParams({ owner_id: ownerId, user_name: userName });
    return api.post<VisitaEntry>(`/visitas/?${params.toString()}`, data);
  },

  getById: (id: string) => api.get<VisitaEntry>(`/visitas/${id}`),

  update: (id: string, data: { coords?: string; visita?: string }) => {
    return api.put<VisitaEntry>(`/visitas/${id}`, data);
  },

  delete: (id: string) => api.delete<{ message: string; id: string }>(`/visitas/${id}`),
};
